import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Profile.css';
import MyChatBot from '../components/MyChatBot';
import SupportChat from '../components/SupportChat';
import ElevatorPitchRecorder from '../components/ElevatorPitchRecorder';
import AvatarViewer from '../components/AvatarViewer';

export default function Profile() {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");
  const [showChatbot, setShowChatbot] = useState(false);
  const [showSupportChat, setShowSupportChat] = useState(false);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const token = localStorage.getItem("token");
    const email = localStorage.getItem("username");

    if (!token || !email) {
      setError("Not logged in.");
      navigate("/login");
      return;
    }

    const fetchProfile = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/profile?email=${email}`, {
          headers: { "Authorization": `Bearer ${token}` }
        });

        if (response.status === 401 || response.status === 403) {
          throw new Error("Unauthorized. Please log in again.");
        }

        if (!response.ok) {
          throw new Error("Failed to fetch profile.");
        }

        const data = await response.json();
        setProfile(data);
      } catch (err) {
        console.error("Profile fetch error:", err);
        setError(err.message);
      }
    };

    fetchProfile();

    const handleSupportChatToggle = () => {
      setShowChatbot(false);
      setShowSupportChat(true);
    };

    window.addEventListener("show-support-chat", handleSupportChatToggle);
    return () => window.removeEventListener("show-support-chat", handleSupportChatToggle);
  }, [navigate, API_BASE_URL]);

  if (error) return <p style={{ color: 'red' }}>{error}</p>;
  if (!profile) return <p>Loading...</p>;

  return (
    <>
      <div className="profile-card">
        <img src="/avatar.png" alt="Avatar" className="avatar" />
        <h2>Welcome to Your Profile</h2>
        <div className="profile-info-row"><strong>Name:</strong> <span>{profile.name}</span></div>
        <div className="profile-info-row"><strong>Title:</strong> <span>{profile.title}</span></div>
        <div className="profile-info-row"><strong>Company:</strong> <span>{profile.company}</span></div>
        <div className="profile-info-row">
          <strong>LinkedIn:</strong> <a href={profile.linkedIn} target="_blank" rel="noopener noreferrer">View LinkedIn</a>
        </div>
        <div className="profile-info-row">
          <strong>Resume:</strong> <a href={`/${profile.resumePath}`} target="_blank" rel="noopener noreferrer">View Resume</a>
        </div>
        <div className="edit-profile-button">
          <button onClick={() => navigate("/edit-profile")}>Edit profile</button>
        </div>
      </div>

      {/* ✅ 3D Avatar Viewer */}
      <div className="avatar-viewer-container">
        <h3>Your 3D Avatar</h3>
        {profile.avatarUrl ? (
          <AvatarViewer modelPath={profile.avatarUrl} />
        ) : (
          <p>No avatar saved yet. You can customize one <a href="/avatar-customize">here</a>.</p>
        )}
      </div>

      {/* ✅ Chatbot Bubble Toggle */}
      <div className="chatbot-toggle">
        {showChatbot && <MyChatBot />}
        <button className="chatbot-bubble" onClick={() => setShowChatbot(prev => !prev)}>
          💬
        </button>
      </div>

      {showSupportChat && <SupportChat />}
      <ElevatorPitchRecorder />
    </>
  );
}
